/**
 * ./src/modules/product/components/samples/ToggleGridLayout.tsx
 *
 * ToggleGridLayout component
 *
 * @since 12/09/2024
 * @copyright DesignShop, 2024
 */
import clsx from 'clsx';

import { Button } from '@/modules/common/components/Button';
import { CardThumbnail } from '@/modules/common/components/icons/CardThumbnail';
import { GridLayout } from '@/modules/common/components/icons/GridLayout';

import useGridLayout from '../../hooks/useGridLayout';

export type ToggleGridLayoutProps = React.HTMLAttributes<HTMLDivElement>;

export const ToggleGridLayout = ({ className }: ToggleGridLayoutProps) => {
  const { gridLayout, setGridLayout } = useGridLayout();

  return (
    <div className={clsx('flex items-center gap-1', className)} data-testid="grid-layout">
      <Button
        variant="outlined-light"
        size={'icon-m'}
        data-testid="default-grid-button"
        onClick={() => setGridLayout('thumbnail')}
        className={`${gridLayout === 'thumbnail' ? 'text-gray-950' : 'text-gray-400'}`}
      >
        <CardThumbnail />
      </Button>
      <Button
        variant="outlined-light"
        size={'icon-m'}
        data-testid="side-by-side-grid-button"
        className={`${gridLayout === 'side-by-side' ? 'text-gray-950' : 'text-gray-400'}`}
        onClick={() => setGridLayout('side-by-side')}
      >
        <GridLayout />
      </Button>
    </div>
  );
};
